import React, { useState } from "react";
import { useForm } from "react-hook-form";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import Inputs from "../../share/input/Inputs";
import SupportTicketQuill from "../SupportTicket/SupportTicketQuill";
import { ReactComponent as Upload } from "../../../Assets/Image/svg/Upload.svg";
import { Modal } from "../../share/modal/Modal";
import UploadFile from "../../share/input/Upload/UploadFile";
import DragAndDrop from "../../share/dragAndDropFile/DragAndDrop";
import { BtnPrimary } from "../../share/buttons/Btn";
import DatePickerInput from "../../share/input/DatePicker";
import moment from "jalali-moment";

function MeetingAnswerModal({
    close,
    homeworks,
    setHomeworks,
    setSelectedSession,
}) {
    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();
    const onSubmit = (data) => console.log("data", data);
    const [upload1, setUpload1] = useState(false);

    const handleModal = () => {
        setUpload1((perv) => !perv);
    };

    const closeModal = (e) => {
        e.stopPropagation();
        setHomeworks("");
        setSelectedSession();
        close();
    };
    return (
        <div className="AddnewsupportTicket relative">
            <button
                onClick={closeModal}
                className="AddnewsupportTicket-cancel absolute  "
            >
                <div>
                    <Cancel />
                </div>
            </button>
            <h3 className=" text-center text-[#77498F] text-[20px] font-bold mb-20">
                اطلاعات تکلیف
            </h3>
            <div className=" mt-[5.6rem]">
                <div className=" grid grid-cols-2 gap-x-0 gap-y-[1.3rem]">
                    <p className=" text-black font-normal text-[1.8rem] leading-[3.2rem]">
                        نام تکلیف:
                    </p>
                    <p className=" text-[#212121E5] font-normal text-[1.4rem] leading-[2.4rem]">
                        {homeworks && homeworks[0]?.homework_name}
                    </p>
                    <p className=" text-black font-normal text-[1.8rem] leading-[3.2rem]">
                        تاریخ پایان:
                    </p>
                    {homeworks?.length > 0 && (
                        <p className=" text-[#212121E5] font-normal text-[1.4rem] leading-[2.4rem]">
                            {moment(homeworks[0]?.homework_end_time)
                                .locale("fa", {
                                    useGregorianParser: true,
                                })
                                .format("HH:mm:ss YYYY/MM/DD")}
                        </p>
                    )}
                </div>
                <div className="my-[3.5rem]">
                    <p className=" text-black font-normal text-[1.8rem] leading-[3.2rem] mb-4">
                        توضیحات:
                    </p>
                    <p className="whitespace-pre-line text-[#212121E5] font-normal text-[1.4rem] leading-[2.4rem] bg-white p-4 rounded-3xl">
                        {homeworks && homeworks[0]?.homework_description}
                    </p>
                </div>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="flex gap-48">
                    <div
                        className="w-full py-[20px] px-[25px] flex border-gray border-[1px] text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] justify-between cursor-pointer"
                        onClick={() => handleModal()}
                    >
                        <span>آپلود فایل</span>
                        <Upload />
                    </div>
                    <BtnPrimary
                        className="w-full py-[20px] px-[25px]"
                        text={`ثبت پاسخ تکلیف`}
                    />
                </div>
            </form>
            <Modal show={upload1} closeModal={handleModal}>
                <DragAndDrop
                    close={handleModal}
                    label=""
                    {...register("photo", { required: false })}
                    error={errors["photo"]}
                    accept=".png , .jpg"
                    type="image"
                />
            </Modal>
        </div>
    );
}

export default MeetingAnswerModal;
